import React, { useRef, useState, forwardRef, useImperativeHandle } from "react";
import classes from "./ShortsAnimation.module.css";
import { MdOutlinePauseCircleFilled, MdOutlinePlayCircleFilled } from "react-icons/md";

const ShortsAnimationPlayer = forwardRef(
    ({ duration = 5000, children, onStart = () => { }, onStop = () => { }, onEnd = () => { }, musicSrc = null }, ref) => {
        const animationContainer = useRef(null);
        const audioRef = useRef(null);
        const [isPlaying, setIsPlaying] = useState(false);
        const [startTime, setStartTime] = useState(0);
        const [hasEnded, setHasEnded] = useState(false); // Track if animation completed
        const animationRef = useRef(null);
        let startTimestamp = useRef(null);

        const animate = (timestamp) => {
            if (!startTimestamp.current) {
                startTimestamp.current = timestamp;
            }
            let elapsed = timestamp - startTimestamp.current + startTime;

            if (elapsed >= duration) {
                cancelAnimationFrame(animationRef.current);
                setIsPlaying(false);
                setHasEnded(true); // Mark animation as ended
                onEnd && onEnd();
                return;
            }

            let progress = elapsed / duration;
            let scale = 1 + 0.2 * progress;
            // let translateX = -10 + 20 * progress;

            if (animationContainer.current) {
                animationContainer.current.style.transform = `scale(${scale})`;
            }

            animationRef.current = requestAnimationFrame(animate);
        };

        const play = () => {
            if (hasEnded) {
                reset();
            }

            startTimestamp.current = null;
            animationRef.current = requestAnimationFrame(animate);
            setIsPlaying(true);
            setHasEnded(false);
            onStart && onStart();

            if (musicSrc) {
                playAudio();
            }
        };

        const pause = () => {
            cancelAnimationFrame(animationRef.current);
            setStartTime(performance.now() - startTimestamp.current);
            setIsPlaying(false);
            onStop && onStop();

            if (musicSrc) {
                pauseAudio();
            }
        };

        const reset = () => {
            cancelAnimationFrame(animationRef.current);
            setStartTime(0);
            setHasEnded(false);
            setIsPlaying(false);

            if (animationContainer.current) {
                animationContainer.current.style.transform = `scale(1) translateX(-10%)`;
            }

            if (musicSrc) {
                audioRef.current.currentTime = 0;
            }
        };

        const playAudio = () => {
            audioRef.current.play();
        };

        const pauseAudio = () => {
            audioRef.current.pause();
        };

        useImperativeHandle(ref, () => ({
            play,
            pause,
            reset
        }));

        return (
            <div className={classes.wrapper}>
                <div ref={animationContainer} className={classes.animationContainer}>
                    {children}
                </div>

                {musicSrc && (
                    <audio preload="auto" ref={audioRef} loop style={{ display: "none" }}>
                        <source src={musicSrc} />
                    </audio>
                )}

                <div className={classes.controls} onClick={isPlaying ? pause : play}>
                    {isPlaying ? (
                        <MdOutlinePauseCircleFilled size={50} color="white" />
                    ) : (
                        <MdOutlinePlayCircleFilled size={50} color="white" />
                    )}
                </div>
            </div>
        );
    }
);

export default ShortsAnimationPlayer;
